import type { useApiFetch } from '@/features/auth'
import { buildQueryString } from '@/lib/buildQueryString'
import type { AppNotification, NotificationsListParams } from '@/features/notifications/types'

type AuthedFetch = ReturnType<typeof useApiFetch>

export interface NotificationsListResult {
  items: AppNotification[]
  page: number
  pageSize: number
  total: number
  totalPages: number
}

export function fetchNotifications(
  authedFetch: AuthedFetch,
  params: NotificationsListParams = {},
): Promise<NotificationsListResult> {
  return authedFetch<NotificationsListResult>(`/api/v1/notifications${buildQueryString(params)}`)
}

export function markNotificationRead(authedFetch: AuthedFetch, id: string): Promise<void> {
  return authedFetch<void>(`/api/v1/notifications/${id}/read`, { method: 'PATCH' })
}

export interface MarkAllReadResult {
  markedReadCount: number
}

export function markAllNotificationsRead(authedFetch: AuthedFetch): Promise<MarkAllReadResult> {
  return authedFetch<MarkAllReadResult>('/api/v1/notifications/read-all', { method: 'POST' })
}
